import React from 'react';
// images
import experienceCalloutImage from  './images/woman-reading-tax-documents-desktop.webp';
// styles
import { ExperienceCalloutStyled } from './styles';

export default ({ id }) => (
  <ExperienceCalloutStyled
    sectionId={`tax-documents-experience-callout-${id}`}
    // configs
    backgroundVariant='darkDefault'
    calloutBackgroundVariant='darkDefault'
    calloutThemeType='darkTheme'
    disableLazyLoad
    isFullWidth
    moduleName='quiz-callout-module'
    moduleVariation='A'
    themeType='darkTheme'
    withBGImage
    withHoverShadow={false}
    // content
    buttonText='Log in'
    headingText='Get your tax forms.'
    imageUrl={experienceCalloutImage.toString()}
    linkUrl='https://plan.northwesternmutual.com/documents/'
  />
);
